import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from './deconstruct-date.function';
import { setTimeTz } from '../set/set-time-tz.function';

export function assertDatesForComparision<T extends IsoDate | IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>( ...a: T[] ): Date[] {
  let type: string | null = null;
  const returnValue: Date[] = []
  for (let t of a) {
    const deconstructed = deconstructDate(t);
    if(type && type !== deconstructed._type)
      throw new Error('assertDatesForComparision: all dates must be of the same type');
    type = deconstructed._type;
    switch (deconstructed._type){
      case 'date':
        returnValue.push(new Date(Date.UTC(deconstructed.year, deconstructed.month - 1, deconstructed.day)));
        break;
      case 'dateTime':
        returnValue.push(new Date(Date.UTC(deconstructed.year, deconstructed.month - 1, deconstructed.day, deconstructed.hours, deconstructed.minutes, deconstructed.seconds, deconstructed.milliseconds)));
        break;
      case 'dateTimeTz':
        let offsetMinutes = 0;
        if (deconstructed.offset !== 'Z')
          offsetMinutes = (deconstructed.offset.offsetHours * 60 + deconstructed.offset.offsetMinutes) * (deconstructed.offset.offsetSign === '-' ? -1 : 1);
        returnValue.push(new Date(Date.UTC(deconstructed.year, deconstructed.month - 1, deconstructed.day, deconstructed.hours, deconstructed.minutes, deconstructed.seconds, deconstructed.milliseconds) - offsetMinutes * 60000));
        break;
      case 'time':
        returnValue.push(new Date(Date.UTC(1970, 0, 1, deconstructed.hours, deconstructed.minutes, deconstructed.seconds, deconstructed.milliseconds)));
        break;
      case 'timeTz':
        t = setTimeTz('1970-01-01' as IsoDate, t as IsoTimeTz) as any;
        returnValue.push(new Date(t));
        break;
      default:
        throw new Error('assertDatesForComparision: invalid date type');
    }
  }
  return returnValue;
}
